// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-footer>a[data-v-2891a856]{color:inherit;-webkit-transition:.15s;transition:.15s;text-decoration:none;padding-top:1px;border-bottom:1px solid transparent}.v-footer>a[data-v-2891a856]:focus,.v-footer>a[data-v-2891a856]:hover{border-color:currentColor}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
